import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import { AuthProvider } from './contexts/AuthContext';
import { ChatProvider } from './contexts/ChatContext';
import SEOHead from './components/SEOHead';

function App() {
  return (
    <AuthProvider>
      <ChatProvider>
        <SEOHead />
        <div className="min-h-screen flex flex-col bg-white">
          <Header />
          <main className="flex-grow pt-20 pb-8">
            <Outlet />
          </main>
          <Footer />
        </div>
      </ChatProvider>
    </AuthProvider>
  );
}

export default App;